import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { fetchBulkOrderCart } from '../../common/bulkOrder'

const useRetryBulkOrderCartFetch = () => {
  const dispatch = useDispatch()

  return useCallback(() => {
    dispatch(fetchBulkOrderCart())
  }, [dispatch])
}

export default useRetryBulkOrderCartFetch
